/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diet_Plan_CrumbInputs */

const en_diet_plan_crumb = /** @type {(inputs: Diet_Plan_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diet plan`)
};

const pl_diet_plan_crumb = /** @type {(inputs: Diet_Plan_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan diety`)
};

/**
* | output |
* | --- |
* | "Diet plan" |
*
* @param {Diet_Plan_CrumbInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const diet_plan_crumb = /** @type {((inputs?: Diet_Plan_CrumbInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diet_Plan_CrumbInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_diet_plan_crumb(inputs)
	return en_diet_plan_crumb(inputs)
});